import React, { useEffect, createElement } from 'react';
import { Quote } from 'lucide-react';
import { WistiaVideo } from './WistiaVideo';
import { CTAButton } from './CTAButton';
function loadWistiaScript(mediaId: string) {
  if (!document.querySelector('script[src="https://fast.wistia.com/player.js"]')) {
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
  }
  const embedSrc = `https://fast.wistia.com/embed/${mediaId}.js`;
  if (!document.querySelector(`script[src="${embedSrc}"]`)) {
    const embedScript = document.createElement('script');
    embedScript.src = embedSrc;
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
  }
}
export function TestimonialsSection() {
  useEffect(() => {
    loadWistiaScript('psa74yg6wr');
    loadWistiaScript('n6ngvv6hee');
    loadWistiaScript('4d7zhpdcnk');
  }, []);
  return <section className="bg-white py-20 px-4" data-id="element-147">
      <div className="max-w-[900px] mx-auto flex flex-col items-center" data-id="element-148">
        <h2 className="md:text-4xl font-bold text-textDark mb-4 text-center text-[28px]" data-id="element-149">
          Cuando haces el ajuste... se nota.
        </h2>
        <p className="text-xl text-textSecondary mb-16 text-center max-w-2xl" data-id="element-150">
          No porque trabajes más. Sino porque con menos horas de trabajo tienes
          más crecimiento.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full mb-16" data-id="element-151">
          <div className="flex flex-col items-center mx-auto w-full" data-id="element-152">
            <div className="mb-6 rounded-xl overflow-hidden shadow-lg" style={{
            width: '100%',
            maxWidth: '320px',
            margin: '0 auto'
          }} data-id="element-153">
              <style data-id="element-154">{`
                wistia-player[media-id='psa74yg6wr']:not(:defined) {
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/psa74yg6wr/swatch');
                  display: block;
                  filter: blur(5px);
                  padding-top: 177.78%;
                }
              `}</style>
              {/* @ts-ignore */}
              <wistia-player media-id="psa74yg6wr" aspect="0.5625" style={{
              width: '100%'
            }} data-id="element-155"></wistia-player>
            </div>
            <p className="text-center text-textSecondary italic text-lg" data-id="element-156">
              "Me di cuenta de todo lo que estaba haciendo que no sumaba. Solo
              con eso, tomé decisiones que venía postergando hace meses."
            </p>
          </div>

          <div className="flex flex-col items-center mx-auto w-full" data-id="element-157">
            <div className="mb-6 rounded-xl overflow-hidden shadow-lg" style={{
            width: '100%',
            maxWidth: '320px',
            margin: '0 auto'
          }} data-id="element-158">
              <style data-id="element-159">{`
                wistia-player[media-id='n6ngvv6hee']:not(:defined) {
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/n6ngvv6hee/swatch');
                  display: block;
                  filter: blur(5px);
                  padding-top: 177.78%;
                }
              `}</style>
              {/* @ts-ignore */}
              <wistia-player media-id="n6ngvv6hee" aspect="0.5625" style={{
              width: '100%'
            }} data-id="element-160"></wistia-player>
            </div>
            <p className="text-center text-textSecondary italic text-lg" data-id="element-161">
              "Liberé horas que ni sabía que estaba perdiendo... y esa misma
              semana mejoraron mis cierres."
            </p>
          </div>

          <div className="flex flex-col items-center mx-auto w-full" data-id="element-162">
            <div className="mb-6 rounded-xl overflow-hidden shadow-lg" style={{
            width: '100%',
            maxWidth: '320px',
            margin: '0 auto'
          }} data-id="element-163">
              <style data-id="element-164">{`
                wistia-player[media-id='4d7zhpdcnk']:not(:defined) {
                  background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/4d7zhpdcnk/swatch');
                  display: block;
                  filter: blur(5px);
                  padding-top: 173.33%;
                }
              `}</style>
              {/* @ts-ignore */}
              <wistia-player media-id="4d7zhpdcnk" aspect="0.5769230769230769" style={{
              width: '100%'
            }} data-id="element-165"></wistia-player>
            </div>
            <p className="text-center text-textSecondary italic text-lg" data-id="element-166">
              "Dejé de sentir que todo dependía de mí. Ahora sé exactamente en
              qué enfocarme para crecer."
            </p>
          </div>
        </div>

        <div className="w-full bg-light rounded-2xl p-8 md:p-12 mb-12 relative text-center" data-id="element-167">
          <Quote className="text-accent absolute top-6 left-6 opacity-20" size={64} data-id="element-168" />
          <p className="text-2xl md:text-3xl text-textDark font-bold italic relative z-10" data-id="element-169">
            "Entendí cuánto vale realmente una hora de mi tiempo... y eso cambió
            completamente cómo trabajo."
          </p>
        </div>

        <p className="text-xl text-textSecondary mb-10 text-center max-w-2xl" data-id="element-170">
          No es magia.
          <br data-id="element-171" />
          Es lo que pasa cuando eliminas las fugas y te concentras en el 20% que
          genera crecimiento.
        </p>

        <CTAButton className="w-full md:w-auto" data-id="element-172">QUIERO VER MI 20%</CTAButton>
      </div>
    </section>;
}